<template>
  <div>
    <lang/>
    <navbar/>
    <transition name="fade">
      <router-view :key="$route.fullPath"/>
    </transition>
    <navfooter/>
  </div>
</template>
<script>
import navbar from '@/components/partials/navbar'
import Navfooter from '@/components/partials/navfooter'
import lang from '@/components/partials/lang'
export default{
    components: {
      Navfooter,
      navbar,
      lang,
    }
}
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/App.vue